import { IAppState } from '../appState';
import { VersicherungsnehmerDashboard } from '../reducers/versicherungsnehmer.reducer';

export const selectVnKdvId = (
  state: IAppState,
): VersicherungsnehmerDashboard['kundenverwaltungID'] =>
  state.versicherungsnehmer.kundenverwaltungID;

export const selectIsVn = (state: IAppState, kdvId: string): boolean =>
  !!kdvId && kdvId === selectVnKdvId(state);
